import React, { ComponentType, Suspense } from 'react'
import { Loading } from '@components/ui/Loading'

/**
 * Wraps a component with ErrorBoundary and Suspense
 * This is a helper function to make route configurations cleaner
 *
 * @param Component - The component to wrap
 * @returns The wrapped component
 */
export const withSuspense = (Component: ComponentType) => (
    <Suspense fallback={<Loading />}>
      <Component />
    </Suspense>
)

/**
 * Helper function to create a lazy-loaded component with Suspense
 *
 * @param importFn - The import function to lazy load the component
 * @returns The wrapped component ready to use in routes
 */
export const lazyWithSuspense = (importFn: () => Promise<{ default: ComponentType }>) => {
  const LazyComponent = React.lazy(importFn)
  return withSuspense(LazyComponent)
}

/**
 * Helper function to create a lazy-loaded component with Suspense
 *
 * @param component - The component to lazy load
 * @param page - The page to import the component from
 * @returns The wrapped component ready to use in routes
 */
export const lazyPage = (component: string, page: string | undefined = 'misc') => lazyWithSuspense(() => import(`@pages/${page && (page !== 'misc') ? `${page}/` : ''}${component}`))
